import React from 'react';
import { paymentFeeLabel } from '../constants/paymentFees';

interface Props {
  method?: string | null;
  className?: string;
}

/** Badge info biaya transaksi per metode (info-only, tak mengubah total).
 *  Warna mengikuti `currentColor` induknya agar aman di 3 konteks
 *  (order page, payment page, editor) termasuk tombol terpilih. */
const PaymentFeeBadge: React.FC<Props> = ({ method, className = '' }) => {
  const label = paymentFeeLabel(method);
  if (!label) return null;
  return (
    <span className={`text-[11px] font-medium shrink-0 opacity-70 ${className}`}>{label}</span>
  );
};

export default PaymentFeeBadge;
